function logoSlider() {
   var sliders = document.getElementById('custom-photo');
   if (sliders) {
      var flkty = new Flickity(sliders, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
          pageDots: false,
      });
      sliders.classList.add('spring-slider-visible');
   }
}
logoSlider();



(function () {
  const hasDataYoutube = document.querySelector('[data-youtube]');
  if (hasDataYoutube) {
    const videos = document.querySelectorAll('[data-youtube]');
    for (let video of videos) {
      let id = new URL(video.href).searchParams.get('v');
      video.setAttribute('data-youtube', id);
      video.setAttribute('role', 'button');
      video.innerHTML =
        `<img srcset="https://img.youtube.com/vi/${id}/maxresdefault.jpg" loading="lazy"><img srcset="https://cdn.shopify.com/s/files/1/0753/0853/2013/files/youtube.png?v=1686745815" loading="lazy" class="youtub-ico"><br>
        ${video.textContent}`;
    }
    
    function clickHandler(event) {
      let link = event.target.closest('[data-youtube]');
      if (!link) return;
      event.preventDefault();
      let id = link.getAttribute('data-youtube');
      let player = document.createElement('div');
      player.innerHTML = `<div class="video-wrapper"><iframe src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
      link.replaceWith(player);
    }
    
    document.addEventListener('click', clickHandler);
  }
})();
